export default __webpack_public_path__ + "static/media/11.e3675c17.pdf";